export default "__VITE_ASSET__BFcAL3Tj__"